const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const ViewEditReportMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5QDcCWYDuBaSqAuWATmAA4D2heAdCYWQMZyyoB2UVr+qAhgDaoAvbnlRkWVDNy5sABADMKMvGQDWYFgGIA2gAYAuolDlmIsYZAAPRAEYAbAFYqATgDsAZgBM96wA5b1jwAWHRcAGhAAT0QfNyoPJ1sEjw8XXydA+zcAXyzwtEwcCHwiUgpqWgYmVnZOET5BSA4IXjANABkAeQBBABEAfQAlAFEABQ6BgBVdAyQQYy4zWasELEDrKnsdNx9rBLc3YJcdW3CohBTAqmtrEJ0nAJvMuxy89GxcAmJySho6RlhmGwOCwuPUBI0wIQ6IR2t1+sMxpNpuZ5qYWOZlvF1kE1j57B4ti58T5Toggh4qLidD54vYfE50ukXiB8u8ip9Sj8Kv9ATUQXV+OCIFRIdCqPQABZgegqGSixR4CIkVrI2ao0TopaIexHZx4tw6FJBHbU0kITZOKgGu4eGLWHUee2BZmswrFL5lX6VAHVYGgwUQqEUcVSmVyoOEJRKlXWGZGMgmDUYxAuQKWwIZakOPwuI5uM0Wq06O72Uu2W0JHwut5ujnfcp-KpA2o8APC7j0ETIMBUVkaIY9ACSE0Go3GU30KITC01oGWWAJLiu1PsiQCuZ8RxOkRs9icjn2XgZOkCtk8J+rBQ+JXrXp5vpbYMaHa7Pb7nV6o8RE7jc2naOTFZbUcbwvBcPxN0yBJAjNQIdmcFJDRce58WOA5LzZd1OQbb1eT9AUGnbTtUG7Xs3g0ABlABVAAhABZYcv3HVV40TRY50QcsqB8LZbD8RIaXiDxtzOHjLmOHx9RuAl7ECbJchZGtrw9LlGx9Zt+VbQiqBfEi33IgA1Lo2kHHougmIYmKRSc1X-JMtQQSSdCuWxAnAtzrDks8zTEqgJKkw0dFk+TXivdkb09bkmz5f1tN00i+wAYU6CjLIRZibNYmdAJ1WI3Fc-FMmLe4GTNa40yoFxbVsXM3F2STwIw2sItU3CH00p8iNfMjMA0OiugGABpKyRy6Ci+lSgA5H8pzY2dLBsXwrRuWxjlLAJkjTMrPMtKrNyCJwfC80smuU7C72i-CtKFHTiIS8jhg6EYhkmkaWL-ObAISbFrDq+kdHtXZtm2iq9qOAI0zcvFTvClScPvDTYpu+L9N6wdJqMkyzIst7Mo+7KHPSHw-NcPEYnuNcwh3BB7WQqhy33eIT2gxqFNdM7byi9SYoI5G7p7D4NESrpJsSoY2ne9V2IWlY3D3K1UlkuC4PxXYyoJZzgn2Pi3CJYI6RhrDObUvDHzbW7usFiiugMtKx2s38pfm5ZNnWX7PM8WST1AnyTz8vijp1FxEm2JxDbrSKTfapHn35kV2Q0Z6BkHDp+g6AAxPoJgACUssyAE0JvFoZEosnpJbs6X52Q4miWpYPkPuLx7DKzdnOuAlrCOKq1nucOWvhy6zbiuPBZ6IYKMS5ORgmFPXsS7ORYAcQHCvPocrAeMte0PF1k9JLxPiyuDy5AlpTwzxPY5bH7uGLu5q7OotvT4-wDQJgGleR1StoS7LteCYcRWOBYm9JdhrEPMJNW1Ndj7itJmTIMQggHBvmzJSsNzpc1Nh1c2KNX54CFuZIYS9xiFx-n-VeeMnaAU3sWSqthEgZH2qHfM1NHQEitPiVIwdixd2sLfTBUdEa81jpbBOPQOj9XRkXX+pdKGO0rs7RAWBkLOScIFfY9I9y1TNMkTYy0aQHG8AEO4AjjZtWEddURL9BadGFrPDor1yFyPLlQxRNCa7LQNMre06iGG6O2EufKiQ6QqzAiFRSYUjaRwsTzKxXUbEJy6FRHO4xhyF3RuncYdEBx9GxpZZx-83HryAZvRI9M6oMn2jJQ0ujjH0KQkSI6sCXBmJiQjOJT88GC3Tl0BibQMmTSyQMHJ-R8kyIoa4hRJSZab3xC5TYp45KOhqk4XRZ5YiPBCPcAGBpg5tNah0x+uDR4JxXpNIYAxjJ9BGFc0uw456XL6Jk7JuTxmFPkbNQBsz7igOzPuM+wV9y6IbhsVIwk1zFniM6NBUSI6HKHjgke3VYDcDQLIOGGgIBiB7KwZAqgeyou7APABAEHIOiuMhBhizGG1JgbwjYngnDxBCYcVpsLMLwsHg-YefMUVouqDITF8pCA0F4MIBQhAAC2VAiVgBJcU75yxPLCWcP4OwiQCQ0nxGabYsRNz2kgquVausYWhU5QPe+2CY4JNIrAAArgAIylfgEQGLsJYpxcCfFahZVOpdVy0l9kgGAw2AyFI3jwnWDKgDS4R0Ab7gOHJJWBzuXWpEbawl-rXWCuFRGMVEqKAyodc66JlAg1VxsGfZymRMhHCCm5I+1MMhLl8HWvE1w9xd3sKmq10cM3PwSvUCAwhc0euxSwXFLAfVvmHcIeVcMK1KMcjxOIdgjqeEzGfNZ9LPLcWCLsTIGY5YZl7Vg-t8TB2zv4COt1UAhUepFQWvAkqZXIDnXgBd2El2AU8l3Em4E+KuFTNogsdhuLUuDo6VITh0Icuanfc9liulx3oLwac7r6yesnd6gl4p0OwC-fWH95LdROmgqrS+LcYHbHWHia+2wvAOAyGeoRnSTndTQxh+9eaxQkHFS+ot+GExEbKCRkNZ9LiwdcmfVyIQggFjpjVTYQU9zFkkmHeDHN2mIptVeqgUruCEBUGO+sMhuCwBkIRlgBCJ1TpnQZozKgB5YAs1gazeBxMy1+mo-aRI9WQ2DmVWj3FNgMMY6uWS7LzUIcEbE45yKX7EDIMqFgD6sN2dw769mGDzFHN5dY0iyXUvpbKAgPFDBR1iGmF55Y+5LQqabqtGublgvwXo-4Rmrg6TRciRaxDbGEt8qS2AFL6hSuUA0E+-jhbpU9X63F-LSLhtFdGyVuG5Xp2VbRDVxVZKJMcLtEes8wdXAiU4g4DYPFmbFjWs8LTuWdM8uW4V+zH6wATds16ir2X0FlrTRelD3U8Xvc+5t-F9AqssF29MpV2o6RxD8PsfK3gkGsLOL42w3F9j2jPAwreVYHv-b7chjjL8Qc3vnZ9qb+aZuCbmzl4nSH2OJdIhT1At6PsbYq5Dnb+hatVt+v7U8JqtUMipmcKqWOj00jPG5DIdVWPxYK8KdD3AihsGw-ZvDcgwB4ElAq2H+3Zlnyuwws8PECReF8Od80xwKkQV8CLg0qCYvaYRc9vTauNdQBp3xgTr6qC6-1xKQ3XzjeYiOpSA0lY3AMnDbB2CfFuIlTPDcTM3De32pILewVyg1CaCoiMcZNEhgDSeRMDog0XoC5psVSqm4DgQTkgkHdZwsC6ziLJuqcljgnl2Erpbemn2SmlLKEVUZlTaA8Eb4N3nbsQcNJsOPwcAjo+1HcIsdwTvO8OIP3TA6R+hnHxGSfKo3Cz8rTTZIzlth3GuGtAkh0Cyb+tLBrh183I9uZCwMgEA4DmCM5crh5z7zjXA3AQZ0gApeAt7Ubt4pCWg1RVTeJILMqZD77cwgFX5YArQUh+BQGyQwFx5wHKK7AUgnqeCN7aywYYHprXRQ5YHLo3CxAIGeDgThpRYkErCPB+Q97CSHRJqrRmp9axZ5YH70FogSBSB3ryAKgErzTUIOShqsEpD0hoFf5mg4FLhHB4jHreDFjIQRJAGWrM5DaQCME0I3B7r4FaKAqwFlSlgkzeBQFBT7DqLf5u6PYe50FPwc4tAWEby7xY47Cpg258KSRnwgqxAbhVTMpazbC0GA7mwioBFAKbDEzkheSNzOHRrUx1R4E0j3BrCxECSJGk7aRH5j7hjQhn6pEyxlhd7IKrL7iAywRuS8GFRrgHwD5E5cok4s43RPrBCBAyC-54CyH2osAQB1EuxVTOCuAAwdzGp1QFjlL4hwT2iUFVT2hlEDGBhigHrmb0A8gyD-4gjmG2QzLLA8TrDpFORx7pCqarENbGibG2jbEeEiHu4A7lGDH5oqZWaQjdiRgpGXFw7X6eDcQRrL5Mq-QS7ahrGvGZDvGOifHGEDbK4vaZozHKIJDBH-KEFApcGpBY4gb3GBQOBGF-Z9GmEq76asg4myzOQhDuArjBDNbIQOH5R+RRZ+DJoW6E6eFM6DZ0ndLsiMkLhLjMqSQGjeAZjdblhlThZQnp40gUmri7FmGZqyoCqYZlCMneDBG2i8Spg450qiSSRXABCljx4Gi7yamilxwloBoyFwyMn0j0ydzXBCE6zuA+TpAkzWmbingMiJAOlYn0kfqmb6lgkR7RDqIbClirhx4mLCTr6OQBn351RBybo7G9EmEikRl4Jca8ifYGkBChY1RMz+CqxcEbSOBdw0gNy8SrjCHomLbiFA4vyGbGbRmUDmaWYeYGkUh8TMa2j7BVTIS5EY56KUpNk1QtmuThl6Z4LFbjZumxmgGIDpCOByZEG0bMzqxeBznJA8SuTJDljLkDp4Ls6c5lmblX6wZLiN7xCph1y7C24ar6qOh2AHAEj5TJBXmXre7VASkMgbDp4hxZhym6o6hWjsJ+C+C2hNlZ456jqyD57qCMlr7rCrTZgbrXBiSaGdrcQ7yRqrh+CHRAVPxDHFgyCOrq4PoACO9qcAeA2FgU9MOwhwSB6iqQzxGwxoQRahrZOQOQQAA */
    predictableActionArguments: true,

    id: "view-edit-report",

    states: {
      processing: {
        states: {
          initialization: {
            states: {
              "waiting for token": {
                always: {
                  target: "#view-edit-report.processing.initialized",
                  cond: "tokenReady",
                },
              },
            },

            initial: "waiting for token",
          },

          initialized: {
            states: {
              idle: {
                on: {
                  LOAD_REPORT: "loading",
                },
              },

              error: {
                on: {
                  LOAD_REPORT: "loading",
                },

                states: {
                  "check error type": {
                    always: [
                      {
                        target: "404 not found",
                        cond: "notFoundError",
                      },
                      {
                        target: "401 access denied",
                        cond: "accessDeniedError",
                      },
                      {
                        target: "400 bad request",
                        cond: "badRequestError",
                      },
                      "500 server error",
                    ],
                  },

                  "404 not found": {},
                  "401 access denied": {},
                  "500 server error": {},
                  "400 bad request": {},
                },

                initial: "check error type",
                entry: "saveError",
              },

              active: {
                initial: "view",

                states: {
                  view: {
                    on: {
                      EDIT_REPORT: {
                        target: "edit",
                        cond: "reportInDraftOrPendingAndNotObfuscated",
                      },

                      LOAD_REPORT:
                        "#view-edit-report.processing.initialized.loading",

                      SUBMIT_REPORT: {
                        target: "submitting report",
                        cond: "reportValidForSubmission",
                      },

                      VALIDATE_REPORT: "validating report",
                      CLOSE_REPORT: "closing report",
                      MARK_REPORT_AS_SENT: "marking report as sent",
                      REOPEN_REPORT: "reopen report",
                      INVALIDATE_REPORT: "invalidate report",
                    },
                  },

                  edit: {
                    on: {
                      CANCEL: {
                        target: "view",
                        actions: "resetChangeSet",
                      },

                      SAVE_REPORT: {
                        target: "saving report",
                        cond: "changeSetNotEmpty",
                      },

                      PERIOD_OF_THE_DAY_SELECTED: {
                        target: "edit",
                        internal: true,
                        cond: "validPeriodOfTheDay",
                        actions: "savePeriodOfTheDay",
                      },

                      DESCRIPTION_CHANGED: {
                        target: "edit",
                        internal: true,
                        actions: "saveDescription",
                      },

                      TARGET_SELECTED: {
                        target: "edit",
                        internal: true,
                        actions: "saveTarget",
                      },

                      CATEGORY_SELECTED: {
                        target: "edit",
                        internal: true,
                        actions: "saveCategory",
                      },

                      DOMAIN_SELECTED: {
                        target: "edit",
                        internal: true,
                        actions: "saveDomain",
                      },

                      LOCATION_SELECTED: {
                        target: "edit",
                        internal: true,
                        actions: "saveLocation",
                      },

                      AUTHORITY_INFORMED_DATE_SELECTED: {
                        target: "edit",
                        internal: true,
                        actions: "saveAuthorityInformedAt",
                      },

                      FAMILY_INFORMED_DATE_SELECTED: {
                        target: "edit",
                        internal: true,
                        actions: "saveFamilyInformedAt",
                      },

                      GENERAL_PRACTITIONER_INFORMED_DATE_SELECTED: {
                        target: "edit",
                        internal: true,
                        actions: "saveGeneralPractitionerInformedAt",
                      },
                    },
                  },

                  "saving report": {
                    invoke: {
                      src: "saveReport",
                      id: "save-report",
                      onDone: {
                        target: "view",
                        actions: ["saveReport", "resetChangeSet"],
                      },
                      onError: "#view-edit-report.processing.initialized.error",
                    },
                  },

                  "submitting report": {
                    invoke: {
                      src: "submitReport",
                      id: "submit-report",

                      onDone: {
                        target: "view",
                        actions: "saveReport",
                      },

                      onError: "#view-edit-report.processing.initialized.error",
                    },
                  },

                  "validating report": {
                    invoke: {
                      src: "validateReport",
                      id: "validate-report",
                      onDone: {
                        target: "view",
                        actions: "saveReport",
                      },
                      onError: "#view-edit-report.processing.initialized.error",
                    },
                  },

                  "closing report": {
                    invoke: {
                      src: "closeReport",
                      id: "close-report",

                      onDone: {
                        target: "view",
                        actions: "saveReport",
                      },

                      onError: "#view-edit-report.processing.initialized.error",
                    },
                  },

                  "marking report as sent": {
                    invoke: {
                      src: "markReportAsSent",
                      id: "mark-report-as-sent",
                      onDone: {
                        target: "view",
                        actions: "saveReport",
                      },
                    },
                  },

                  "reopen report": {
                    invoke: {
                      src: "reopenReport",

                      onDone: {
                        target: "view",
                        actions: "saveReport",
                      },

                      onError: "#view-edit-report.processing.initialized.error",
                    },
                  },

                  "invalidate report": {
                    invoke: {
                      src: "invalidateReport",

                      onDone: {
                        target: "view",
                        actions: "saveReport",
                      },

                      onError: "#view-edit-report.processing.initialized.error",
                    },
                  },
                },
              },

              loading: {
                invoke: {
                  src: "fetchReport",
                  id: "fetch-report",

                  onDone: {
                    target:
                      "#view-edit-report.processing.initialized.active.view",
                    actions: "saveReport",
                  },

                  onError: "#view-edit-report.processing.initialized.error",
                },
              },
            },

            initial: "idle",
          },
        },

        initial: "initialization",
      },

      "updating token": {
        on: {
          UPDATE_BEARER_TOKEN: {
            target: "updating token",
            cond: "validToken",
            actions: ["saveToken"],
            internal: true,
          },
        },
      },
    },

    type: "parallel",
  },
  {
    guards: guards,
    actions: actions,
    services: services,
  },
);

export { ViewEditReportMachine };
